import React from 'react'
import Header from './Header'
import { Link } from 'react-router-dom'
// import img from "./cal.webp"
const Home = () => {
  return (
    <div className='body5'>
    <Header/>
    <br/><br/><br/>
    <section className="articles">
  <article>
    <div className="article-wrapper">
      <figure>
        <img src="https://www.pnbmetlife.com/content/dam/pnb-metlife/images/icons/bmi-calculator/meter.png" alt="" />
      </figure>
      <div className="article-body">
        <h2>BMI Calculator</h2>
        <p>
        BMI provides an idea of the amount of fat someone may have and if any changes are required. Being able to calculate whether someone is obese, underweight, overweight or at their ideal weight helps measure the risk of other illnesses. An unhealthy weight might make one prone to a range of chronic and lifestyle diseases. 
        </p>
        <Link to="/bmicalculator " className="read-more">
          Calculate Your BMI <span className="sr-only">about this is some title</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </Link>
      </div>
    </div>
  </article>
  <article>

    <div className="article-wrapper">
      <figure>
        <img src="https://i.insider.com/6064c04cdaf0f10018f994a4?width=1000&format=jpeg&auto=webp" alt="" />
      </figure>
      <div className="article-body">
        <h2>Simple interest Calculator</h2>
        <p>
        It is the interest only on the principal amount as a percentage of the principal amount. Borrowers will benefit from simple interest as they have to pay interest only on loans taken. In other words, simple interest is the amount that one pays to the borrower for using the borrowed money for a fixed period.
        </p>
        <Link to="/sicalculator" className="read-more">
        Calculate Simple Interest<span className="sr-only">about this is some title</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </Link>
      </div>
    </div>
  </article>
  <article>

    <div className="article-wrapper">
      <figure>
        <img src="https://sqy7rm.media.zestyio.com/Compound-Interest-Formula-Mobile.png" alt="" />
      </figure>
      <div className="article-body">
        <h2> Compound Interest Calculatore</h2>
        <p>
        Unlike simple interest, which gains interest only on the principal sum, compound interest (CI) earns interest on the previously earned interest. The interest is added to the principal amount. The whole principle revolves around generating high returns by compounding the interest received on the principal sum. 
        </p>
        <Link to="/cicalculator" className="read-more">
          Calculate Compound Interest <span className="sr-only">about this is some title</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </Link>
      </div>
    </div>
  </article>
  <article>

    <div className="article-wrapper">
      <figure>
        <img src="https://previews.123rf.com/images/stockgiu/stockgiu1801/stockgiu180100328/92948883-happy-and-cute-calculator-object-kawaii-vector-illustration.jpg" alt="" />
      </figure>
      <div className="article-body">
        <h2>Calculator</h2>
        <p>
        A calculator is a device that performs arithmetic operations on numbers. Basic calculators can do only addition, subtraction, multiplication and division mathematical calculations.
        </p>
        <Link to="/calculator" className="read-more">
          Calculate <span className="sr-only">about this is some title</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </Link>
      </div>
    </div>
  </article>
</section>
 <p className="home-footer">Created by Samridhi Sachdeva.</p>
{/* <img src={img} alt='calculator images' classNameName='imge'/> */}
    </div>
  )
}

export default Home
